import { CommonResultId } from '../common/CommonResultId.js'
import { EventStatusId } from '../EventStatusId.js'
import { ResultId } from '../ResultId.js'
import { BasketballResultId } from './BasketballResultId.js'
import { BasketballEventStatusId } from './EventStatusId.js'

export const basketballStatusResultsMap: {
  [key in EventStatusId]?: ResultId[]
} = {
  [BasketballEventStatusId.FirstHalf]: [
    CommonResultId.Result,
    CommonResultId.RegularTime,
    BasketballResultId.FirstHalf,
  ],
  [BasketballEventStatusId.SecondHalf]: [
    CommonResultId.Result,
    CommonResultId.RegularTime,
    BasketballResultId.SecondHalf,
  ],
  [BasketballEventStatusId.FirstQuarter]: [
    CommonResultId.Result,
    CommonResultId.RegularTime,
    BasketballResultId.FirstQuarter,
    BasketballResultId.FirstHalf,
  ],
  [BasketballEventStatusId.SecondQuarter]: [
    CommonResultId.Result,
    CommonResultId.RegularTime,
    BasketballResultId.SecondQuarter,
    BasketballResultId.FirstHalf,
  ],
  [BasketballEventStatusId.ThirdQuarter]: [
    CommonResultId.Result,
    CommonResultId.RegularTime,
    BasketballResultId.ThirdQuarter,
    BasketballResultId.SecondHalf,
  ],
  [BasketballEventStatusId.FourthQuarter]: [
    CommonResultId.Result,
    CommonResultId.RegularTime,
    BasketballResultId.FourthQuarter,
    BasketballResultId.SecondHalf,
  ],
}
